import { GROUP_MAILBOX, PRIVATE_DL, PUBLIC_DL, RECOMMENDED_GROUP } from '../constants';

export function isDLOrGroup(mailboxType: string) {
    switch (mailboxType) {
        case PUBLIC_DL:
        case PRIVATE_DL:
        case GROUP_MAILBOX:
        case RECOMMENDED_GROUP:
            return true;
        default:
            return false;
    }
}
